<template>
  <v-dialog
    :value="open"
    @input="update"
    overlay-color="#000"
    overlay-opacity="0.66"
    :persistent="persistent"
    max-width="500"
    :style="{'z-index' : zIndex}"
  >
    <v-card class="dialog-card">
      <v-card-title class="d-flex justify-space-between " :class="!persistent ? 'dialog-title-close' : null ">
        <span>
          {{ l_header }}
        </span>
        <v-btn v-if="!persistent" icon @click="update(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="white100">
        <text-group
          invert
          large
          :utext="l_text"
          :btext="l_title"
          :btextBold="false"
        ></text-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer v-if="!isMobile"></v-spacer>
        <v-btn
          v-if="!hideCancel"
          :class="['btn-secondary']"
          @click="cancelAction()"
        >
          {{ yesNo ? 'Nie' : 'Zrušiť' }}
        </v-btn>
        <v-btn 
          class="btn-primary" 
          @click="doAction()" 
          >
          {{ yesNo ? 'Áno' : 'Ok' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import TextGroup from './TextGroup.vue';
import { mapGetters } from 'vuex';
export default {
  components: { TextGroup },
  props: {
    action: Function,
    cancel: Function,
    value: Boolean,
    title: String,
    text: String,
    header: String,
    persistent: Boolean,
    hideCancel: Boolean,
    yesNo: Boolean,
    zIndex:{
      type: Number,
      default: 204
    }
  },
  watch: {
    value(val) {
      this.open = val;
    },
    title(val) {
      this.l_title = val;
    },
    text(val) {
      this.l_text = val;
    },
  },
  data() {
    return {
      open: this.value,
      l_title: this.title,
      l_text: this.text,
      l_header: this.header ?? 'Upozornenie',
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    doAction() {
      this.update(false);
      if (this.action) this.action();
    },
    update(val) {
      this.$emit('input', val);
      this.open = val;
    },
    cancelAction() {
      this.update(false);
      if (this.cancel){
        this.cancel();
      } 
    }
  },
};
</script>
